<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addTermsOfPayment></addTermsOfPayment>
    </v-dialog>

</template>

<script>
    import {TermsOfPaymentSettings} from '../../../store/namespace-helper'

    import addTermsOfPayment from '../../Shared/AddTermsOfPayment.vue'

    export default {
      name: 'add-new-terms-of-payment-dialog',
      components: {
        addTermsOfPayment
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[TermsOfPaymentSettings.getters.getOpenNewDialogState]
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Settings/TermsOfPayment/AddTermsOfPaymentDialog.vue